export enum ActivityType {
    TEXT_INPUT = "Text input",
    SINGLE_CHOICE = "Single choice",
    MULTIPLE_CHOICE = "Multiple Choice"
}